﻿<template>
    <div class="cart-summary w-full md:w-5/12 lg:w-4/12">
        <div class="basket-summary border border-form rounded w-full p-8 md:p-4 lg:p-8 flex flex-col">

            <itinerary_breakdown></itinerary_breakdown>
            <hr />
            <trip_summary></trip_summary>
            <trip_summary_discount v-if="!isPaymentLink()"></trip_summary_discount>
            <hr />

            <div class="summary-options section" :hidden="No_Deposit()" id="payment_checkout">

                <h6 class="title text-base text-heading font-bold">Payment Options</h6>
                <fieldset class="option-group accommodation" x-data="radioGroup()">

                    <div x-ref="radiogroup">

                        <div class="item" :class="{ '': !full_payment, 'checked': full_payment}">
                            <div class="option-input">
                                <input id="settings-option-8" name="myradio5" type="radio" checked @click="full_payment_selected()">
                            </div>
                            <div class="option-content">
                                <label for="settings-option-8">
                                    <span class="room">
                                        {{get_total_outstanding_Formatted()}} full amount
                                    </span>
                                </label>
                            </div>
                        </div>

                        <div class="item" :class="{ '': !deposit, 'checked': deposit}">
                            <div class="option-input">
                                <input id="settings-option-9" name="myradio5" type="radio" @click="deposit_selected()">
                            </div>
                            <div class="option-content">
                                <label for="settings-option-9">
                                    <span class="room">
                                        {{get_Total_Deposit_Formatted()}} deposit
                                    </span>
                                </label>
                            </div>
                        </div>

                    </div>
                </fieldset>

            </div>

            <div class="summary-total section">
                <div class="row">
                    <h6 class="title text-base text-heading font-bold">Total Price</h6>
                    <p id="totalPrice" class="balance text-black text-2xl text-action font-bold mb-0">{{get_Total_Selected_Formatted()}} <span class="font-normal text-lg">{{get_Currency()}}</span> <small class="font-normal text-sm">includes all taxes.</small></p>
                    <p class="balance-remaning text-sm mt-2 mb-0" :hidden="full_payment">Balance of <span class="font-bold">{{get_Balance()}} {{get_Currency()}}</span></p>
                </div>
            </div>

            <hr />
            <div v-if="!isAgent_Login()">
                <p class="m-auto font-bold text-black pt-2">By booking with us you agree to our <a :href=terms_policy() target="_blank">terms and conditions</a></p>
                <div class="flex my-4">
                    <input v-model="agreeCheckbox" type="checkbox" class="focus:ring-action text-action border-grey-light rounded mr-5 mt-1 cursor-pointer">
                    <label @click="agreeCheckbox = !agreeCheckbox">I have read and agree with the terms and conditions</label>
                </div>
            </div>

            <div class="summary-action">
                <div v-if="displayCompleteRequired" class="row">
                    <span class="text-xl text-status-warning" >Please complete all required passenger details to continue </span>
                    <span class="text text-status-warning" > (Passenger {{failingPassengerIndex +1}} is missing details)</span>

                </div>
                <div class="row">
                    <div v-if="agreeCheckbox">
                        <button v-if="!isloading" type="button" class="button button-pink-book full" @click="check_out()">{{checkout}}</button>
                        <button v-else type="button" class="button button-pink-book full" disabled>
                            <svg class="animate-spin h-5 w-5 mr-3 inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 512 512" stroke="currentColor">
                                <path fill="currentColor" d="M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"></path>
                            </svg>
                            Checking details...
                        </button>

                    </div>
                    <button v-else type="button" class="border-grey-default bg-form border-blank button text-base text-action full" disabled>Agree to continue</button>
                </div>
                <div class="row">
                    <small class="block mt-4 text-grey-default">{{get_Contact_Text()}}</small>
                </div>
            </div>

            <div id="payment-gateway-component"></div>
        </div>
    </div>
</template>

<script lang="ts" src="./summary.ts"></script>